import React from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import { Heart, FileText, Calculator, FolderOpen } from 'lucide-react';
import { WebSocketProvider } from './context/WebSocketContext';
import ComparePage from './pages/ComparePage';
import PenaltyPage from './pages/PenaltyPage';
import MattersPage from './pages/MattersPage';
import MatterPage from './pages/MatterPage';
import DebugConsole from './DebugConsole';

const NAV_ITEMS = [
  { to: '/', label: 'Сравнение', icon: FileText, beta: false },
  { to: '/matters', label: 'Договоры', icon: FolderOpen, beta: false },
  { to: '/penalty', label: 'Неустойка', icon: Calculator, beta: true },
];

function NavTabs() {
  return (
    <nav className="flex flex-wrap gap-2">
      {NAV_ITEMS.map(({ to, label, icon: Icon, beta }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          className={({ isActive }) =>
            `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition ${
              isActive
                ? 'bg-gradient-to-r from-pink-500 to-rose-500 text-white shadow'
                : 'bg-white text-gray-600 border border-gray-200 hover:border-pink-300 hover:text-pink-600'
            }`
          }
        >
          <Icon className="w-4 h-4" /> {label}
          {beta && (
            <span className="ml-0.5 text-[9px] uppercase font-semibold px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-700">бета</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-rose-100">
      <header className="bg-white shadow-sm border-b border-rose-200">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-gradient-to-r from-pink-500 to-rose-500 rounded-lg">
              <Heart className="w-6 h-6 text-white" fill="white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-pink-600 to-rose-600 bg-clip-text text-transparent">
                Для Бубочки от Бусины
              </h1>
              <p className="text-sm text-rose-400">Самому гениальному юристу</p>
            </div>
          </div>
          <NavTabs />
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        {children}
      </main>

      <footer className="mt-auto py-6 text-center text-rose-400 text-sm">
        <p>Надеюсь не сломается</p>
      </footer>

      <DebugConsole />
    </div>
  );
}

export default function App() {
  return (
    <WebSocketProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<ComparePage />} />
            <Route path="/penalty" element={<PenaltyPage />} />
            <Route path="/matters" element={<MattersPage />} />
            <Route path="/matters/:id" element={<MatterPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </WebSocketProvider>
  );
}
